import { useState, useEffect } from 'react';
import { detectThemeSync, watchThemeChanges } from '../../utils/themeUtils';

/**
 * Custom hook for theme management
 * 
 * Provides theme state and automatic theme change detection.
 * Prevents theme flash by synchronously detecting initial theme.
 * 
 * @returns {object} { isDark, currentTheme }
 * 
 * @example
 * const { isDark, currentTheme } = useTheme();
 * const backgroundColor = isDark ? '#232329' : '#ffffff';
 */
export const useTheme = () => {
  const [currentTheme, setCurrentTheme] = useState(() => detectThemeSync());
  const isDark = currentTheme === 'dark';

  useEffect(() => {
    const cleanup = watchThemeChanges((newTheme) => {
      setCurrentTheme(newTheme);
    });

    return cleanup;
  }, []);

  return { isDark, currentTheme };
};

export default useTheme;

